import { render, staticRenderFns } from "./PlatonInputDataList.vue?vue&type=template&id=205e554b&"
import script from "./PlatonInputDataList.vue?vue&type=script&lang=js&"
export * from "./PlatonInputDataList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports